import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import { buildImageSizes } from '@eliadmin/core/src/components/image/image-helpers';
import Link from '@eliadmin/core/src/components/link';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { getTextFromHTML } from '@eliadmin/core/src/utils/misc-utils';
import { Button } from '@eliadmin/core/src/components/ui/button';

import { MdOutlineKeyboardArrowRight } from 'react-icons/md';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

export const ReferenceCard = ({ reference }: { reference: Reference }) => {
  const textContent = getTextFromHTML(reference.description);
  const imageUrl = reference?.image?.url?.trim() || '/images/placeholder.png';

  return (
    <div className="relative col-span-1 h-[215px] w-full sm:h-[250px] md:h-[220px] lg:h-[380px]">
      <Image
        src={imageUrl}
        alt={resolveImageAlt(reference?.image, reference?.name)}
        fill
        style={{ objectFit: 'cover', objectPosition: 'center' }}
        sizes={buildImageSizes([
          { min: 'xl', size: '600px' },
          { min: 'md', size: '50vw' },
          { size: '100vw' },
        ])}
        loading="lazy"
      />
      <div className="absolute -bottom-[90px] left-1/2 flex w-[94%] -translate-x-1/2 items-center justify-between gap-4 overflow-hidden rounded-[6px] bg-white/80 p-6 sm:-bottom-[170px] sm:p-8">
        <div className="flex w-full flex-col items-start justify-start gap-2.5 sm:max-w-[470px] sm:gap-4">
          <h2 data-ea-visual-tag="h3" className="line-clamp-2 h-[36px] text-sm font-bold text-foreground sm:h-[42px] sm:text-base lg:h-[60px] lg:text-xl xl:h-[62px] xl:text-2xl">
            {reference.name}
          </h2>
          <HtmlRendererRaw
            as="p"
            className="line-clamp-3 h-[50px] text-xs text-muted-foreground sm:h-[64px] sm:text-sm lg:line-clamp-4 lg:h-[80px]"
            html={textContent}
          />
        </div>
        <Button
          asChild
          className="flex max-h-6 min-h-6 min-w-6 max-w-6 items-center justify-center p-0 text-white sm:max-h-[32px] sm:min-h-[32px] sm:min-w-[32px] sm:max-w-[32px] lg:max-h-[52px] lg:min-h-[52px] lg:min-w-[52px] lg:max-w-[52px]"
        >
          <Link prefetch={false} href={reference.slug} aria-label={reference.name}>
            <MdOutlineKeyboardArrowRight size={24} />
          </Link>
        </Button>
      </div>
    </div>
  );
};
